import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import { useLanguage } from '../../i18n/LanguageContext';
import { NodeCardShell } from './NodeCardShell';
import { NodeCardProps } from './NodeCardProps';

export const VacuumNodeCard: React.FC<NodeCardProps> = ({
  node, index, onCommand, onSettingsChange, onEditOpen,
}) => {
  const { t } = useLanguage();
  const s = node.settings ?? {};
  const mode = s.mode ?? 'auto';

  const changeMode = (m: string) => {
    onSettingsChange({ ...s, mode: m });
    onCommand('setMode', { value: m });
  };

  const modes = [
    { value: 'auto',   label: t.vacuumModeAuto   },
    { value: 'spot',   label: t.vacuumModeSpot   },
    { value: 'silent', label: t.vacuumModeSilent },
    { value: 'max',    label: t.vacuumModeMax    },
  ];

  return (
    <NodeCardShell node={node} index={index} onEditOpen={onEditOpen}>
      <Box display="flex" gap={1} mb={1.5}>
        <Button
          variant="outlined" size="small"
          onClick={() => onCommand('start')} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.vacuumStart}
        </Button>
        <Button
          variant="outlined" size="small"
          onClick={() => onCommand('pause')} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.vacuumPause}
        </Button>
        <Button
          variant="outlined" size="small"
          onClick={() => onCommand('dock')} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.vacuumDock}
        </Button>
      </Box>

      <Typography variant="caption" color="text.secondary">{t.vacuumMode}</Typography>
      <Box display="flex" gap={0.5} mt={0.5} mb={s.battery !== undefined ? 1 : 0} flexWrap="wrap">
        {modes.map(m => (
          <Chip
            key={m.value} label={m.label} size="small"
            variant={mode === m.value ? 'filled' : 'outlined'}
            onClick={() => changeMode(m.value)}
          />
        ))}
      </Box>

      {s.battery !== undefined && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {t.vacuumBattery}: {s.battery}%
        </Typography>
      )}
    </NodeCardShell>
  );
};
